import { render, staticRenderFns } from "./Inquiry.vue?vue&type=template&id=bb7fa53a&scoped=true&"
import script from "./Inquiry.vue?vue&type=script&lang=js&"
export * from "./Inquiry.vue?vue&type=script&lang=js&"
import style1 from "./Inquiry.vue?vue&type=style&index=1&id=bb7fa53a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb7fa53a",
  null
  
)

export default component.exports